<template>
  <div class="col-md-12 col-lg-6 item">
    <h2 class="smokeheadlineh2 wow fadeInRight downloadsHeadline">
      {{ $t("downloads") }}
    </h2>
    <div id="Menu4" class="col-12 menu4">
      <div class="text-left downloadsContentContainer">
        <div
          v-for="(information, index) in downloadItems"
          :key="information.name"
        >
          <div class="row" v-if="information.type === 'link'">
            <a
              :href="information.hyperlink"
              class="row download-link"
              target="_blank"
            >
              <img
                class="downloads__image col-8 d-none d-sm-block"
                :src="information.img"
              />
              <p class="sectionSixh4 col-12">{{ $t(information.name) }}</p>
            </a>
          </div>
          <div class="row" v-else>
            <div v-if="information.img" class="col-8 d-none d-sm-block">
              <PdfDocument :name="information.path">
                <img class="downloads__image" :src="information.img" />
              </PdfDocument>
            </div>
            <div class="col-12">
              <PdfDocument :name="information.path">
                <p class="sectionSixh4">{{ $t(information.name) }}</p>
              </PdfDocument>
            </div>
          </div>
          <hr v-if="index < downloadItems.length - 1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import downloadData from "@/data/downloads.json";
import PdfDocument from "@/components/PdfDocument";
export default {
  name: "Downloads",
  components: {
    PdfDocument
  },
  data() {
    return {
      downloadItems: []
    };
  },
  mounted() {
    this.setup();
  },
  watch: {
    "$i18n.locale"() {
      this.setup();
    }
  },
  methods: {
    setup() {
      this.downloadItems = downloadData.map(item => {
        return {
          ...item,
          img: item.img ? this.$store.getters[item.img] : undefined,
          hyperlink: item.hyperlink ? this.$store.getters[item.hyperlink] : undefined
        };
      });
    }
  }
};
</script>

<style scoped>
.downloadsHeadline {
  margin: 80px 0 50px;
  color: black;
  letter-spacing: 6px;
}
@media (max-width: 575.98px) {
  .downloadsHeadline {
    margin: 0px 0 0px;
  }
}
.menu4 {
  display: inline;
}
.downloadsContentContainer {
  width: 100%;
  height: auto;
  overflow: auto;
  background-color: #00aeef;
  border-radius: 20px;
  padding: 30px 20px;
}
a {
  text-decoration: none;
  color: white;
}
.download-link {
  display: block;
}
p {
  line-height: 1.2;
}
.downloads__image {
  margin-bottom: 15px;
}
hr {
  color: white;
  border: 3px solid white;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
